var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "person_black_24dp_5_",
    "data-name": "person_black_24dp (5)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.996,
    height: 21.996,
    viewBox: "0 0 21.996 21.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8279",
    "data-name": "Path 8279",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8280",
    "data-name": "Path 8280",
    d: "M11.332,11.332A3.666,3.666,0,1,0,7.666,7.666,3.665,3.665,0,0,0,11.332,11.332Zm0,1.833C8.885,13.165,4,14.393,4,16.831v.917a.919.919,0,0,0,.917.917H17.748a.919.919,0,0,0,.917-.917v-.917C18.664,14.393,13.779,13.165,11.332,13.165Z",
    transform: "translate(-0.334 -0.334)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.2c9d02225990f173903ef2149dc81b58.svg";
export { ForwardRef as ReactComponent };